import React, { useState, useEffect } from "react";
import { observer, inject } from "mobx-react";
import { useTranslation } from "react-i18next";
import { Tabs, Button } from "../UI";
import { Tab } from "../UI/Tabs";
import LoadingContainer from "../layouts/LoadingContainer";
import MonthPicker from "../components/MonthPicker";
import NewExpense from "../components/NewExpense";
import MobileCalender from "../UI/Calender/MobileCalender";
import UpdateMonthReport from "../components/UpdateMonthReport";
import MobileHeader from "../layouts/MobileHeader";
import { SelectStatus } from "../UI/Select";
import { useNavigate } from "react-router-dom";
import ErrorNotification from "../components/ErrorNotification";
import ReportDetailMobileRow from "../components/ReportDetailMobileRow";
import ExpDetailMobileRow from "../components/ExpDetailMobileRow";
import WorkHoursClac from "../components/WorkHoursClac";
import { EmptyListMessage } from "../components/Common";
import MobileScrollList, { BOTTOM_BAR_CLEARANCE } from "../components/MobileScrollList";

const MonthReportsMobile = ({
  monthReportsStore,
  expKeys,
  monthReports,
  handelWorkHoursCalc,
  handelRowDeleteClick,
  handleDateChange,
  handleStatusChange,
  onSaveExpense,
  onSaveReport,
  date,
  tab,
  setTab,
  isListLoading,
  statuses,
  gl,
  period,
  error,
}) => {
  const { t } = useTranslation("month_reports");
  const [selectedDate, setSelectedDate] = useState(date);
  const [showNewExpenseModal, setShowNewExpenseModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [calencderView, setCalencderView] = useState(false);
  const navigate = useNavigate();
  const options =
    statuses
      ?.filter((stat) => stat.STATDES === "טיוטא" || stat.STATDES === "לאישור")
      .map((stat) => ({
        value: stat.DOCSTATUS,
        label: stat.STATDES,
      })) || [];
  const [showErrorNotification, setShowErrorNotification] = useState({
    show: false,
    text: "",
  });

  const keys = [
    { key: "DAYNAME", width: "5%" },
    { key: "STANDARD", width: "5%" },
    { key: "ILL", width: "5%" },
    { key: "SERV", width: "5%" },
    { key: "VAC", width: "5%" },
    { key: "HOLIDAYDES", width: "10%" },
    { key: "DES", width: "10%" },
    { key: "EXTFILEDES", width: "15%", link: true },
  ];

  const monthReportsKeys = [
    { key: "MONTHLYHOURS", width: "10%" },
    { key: "REPORTEDHOURS", width: "15%" },
    { key: "ILLHOURS", width: "10%" },
    { key: "VACHOURS", width: "10%" },
    { key: "SERVHOURS", width: "10%" },
    { key: "EXTRAHOURS", width: "10%" },
    { key: "MISSHOURS", width: "10%" },
  ];

  useEffect(() => {
    if (!!error) {
      setShowErrorNotification({
        show: true,
        text: error,
      });
    } else {
      setShowErrorNotification({
        show: false,
        text: "",
      });
    }
  }, [error]);

  const handelExpRowClick = (e, exp) => {
    monthReportsStore.setSelectedExpense({
      EXTFILENUM: exp.EXTFILENUM,
      PERIOD: monthReports.PERIOD,
      GL: monthReports.GL,
      data: exp,
    });

    navigate("/expense");
  };

  const handelRepRowClick = (e, rep) => {
    monthReportsStore.setSelectedReport({
      PERIOD: monthReports.PERIOD,
      GL: monthReports.GL,
      data: rep,
    });

    navigate("/update_report");
  };

  const handelNewExpense = (report) => {
    monthReportsStore.setSelectedExpense({
      PERIOD: report.PERIOD,
      GL: report.GL,
    });
    navigate("/expense");
  };

  return (
    <>
      <LoadingContainer>
        <MobileHeader
          title={t("month_reports_title")}
          date={date}
          setDate={handleDateChange}
          setCalencderView={tab === "1" ? setCalencderView : null}
          calencderView={calencderView}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-between",
              marginTop: 10,
              padding: "0 12px",
            }}>
            <MonthPicker startDate={date} handleDateChange={handleDateChange} />
            <SelectStatus
              style={{
                flex: "0 1 30%",
              }}
              options={options}
              placeholder={t("choose")}
              value={monthReports?.STATDES || options[0]}
              backgroundColor={monthReports?.VCOLORNAME}
              onChange={(value) => handleStatusChange(value)}></SelectStatus>
          </div>
          <Tabs value={tab} tabChange={setTab}>
            <Tab value="1" label={t("month_report")}>
              <MobileScrollList>
                <LoadingContainer isLoading={isListLoading}>
                  {!calencderView ? (
                    <>
                      {!monthReports?.REP_EMPMONTH_SUBFORM?.length && (
                        <EmptyListMessage text={t("no_items")} />
                      )}
                      {monthReports?.REP_EMPMONTH_SUBFORM?.map((report, index) => (
                        <ReportDetailMobileRow
                          keys={keys}
                          key={index}
                          report={report}
                          index={index}
                          handelRowClick={handelRepRowClick}
                        />
                      ))}
                    </>
                  ) : (
                    <MobileCalender
                      date={selectedDate}
                      data={monthReports?.REP_EMPMONTH_SUBFORM || []}
                      setSelectedDate={setSelectedDate}
                    />
                  )}
                </LoadingContainer>
                <WorkHoursClac
                  data={monthReports}
                  keys={monthReportsKeys}
                  handelWorkHoursCalc={handelWorkHoursCalc}
                />
              </MobileScrollList>
            </Tab>
            <Tab value="2" label={t("expenses")}>
              <MobileScrollList bottomPadding={BOTTOM_BAR_CLEARANCE}>
                <LoadingContainer isLoading={isListLoading}>
                  {!monthReports?.REP_EMPEXPRETFILES_SUBFORM?.length && (
                    <EmptyListMessage text={t("no_expenses")} />
                  )}
                  {monthReports?.REP_EMPEXPRETFILES_SUBFORM?.map((exp, index) => (
                    <ExpDetailMobileRow
                      keys={expKeys}
                      key={index}
                      exp={exp}
                      index={index}
                      handelRowDeleteClick={handelRowDeleteClick}
                      handelRowClick={handelExpRowClick} // linkTo={linkTo}
                    />
                  ))}
                </LoadingContainer>
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "fixed",
                    zIndex: 1000,
                    bottom: 0,
                    padding: 14,
                    borderTop: `1px solid #CBCED5`,
                    backgroundColor: "white",
                  }}>
                  <Button
                    onClick={() => {
                      handelNewExpense(monthReports);
                    }}
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                      padding: "0 47px",
                      textAlign: "center",
                      width: "fit-content",
                    }}>
                    {t("new_expense")}
                  </Button>
                </div>
              </MobileScrollList>
            </Tab>
          </Tabs>
        </MobileHeader>
        {showErrorNotification.show && (
          <ErrorNotification
            text={showErrorNotification.text}
            onClose={() => setShowErrorNotification({ show: false })}
          />
        )}
      </LoadingContainer>
      {showNewExpenseModal === true && (
        <NewExpense
          onClose={setShowNewExpenseModal}
          onSave={onSaveExpense}
          period={period}
          gl={gl}
        />
      )}
      {showUpdateModal === true && (
        <UpdateMonthReport
          onClose={setShowUpdateModal}
          onSave={onSaveReport}
          period={period}
          gl={gl}
        />
      )}
    </>
  );
};

export default inject(
  "userStore",
  "monthReportsStore"
)(observer(MonthReportsMobile));
